const OAuthURL = {
  facebook:
    "http://localhost:8080/oauth2/authorize/facebook?redirectUrl=http://localhost:3000/oauth",
  google:
    "http://localhost:8080/oauth2/authorize/google?redirectUrl=http://localhost:3000/oauth",
};

export default OAuthURL;
